import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

interface Survey {
  survey_id: string;
  survey_number: string;
  survey_title: string;
  survey_description: string;
  status: string;
  created_date_time: string;
  total_assigned: number;
  total_completed: number;
  completion_percentage: string;
  responses: any[];
}

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  surveys: Survey[] = [];
  loading = true;
  error = '';

  private baseUrl = 'https://test.shajipaints.com/dev/FactoryCustomerSurvey';

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadSurveys();
  }

  loadSurveys(): void {
    this.loading = true;
    this.error = '';

    this.http.get<any>(`${this.baseUrl}/view`).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          // Only show surveys that have at least one response
          this.surveys = response.data.filter((s: any) => 
            s.responses && s.responses.length > 0
          );
        } else {
          this.error = 'Failed to load surveys';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading surveys:', err);
        this.error = 'Error loading surveys. Please try again.';
        this.loading = false;
      }
    });
  }

  viewFeedbackDetail(surveyId: string): void {
    this.router.navigate(['admin/customer-survey-menu/feedback-detail', surveyId]);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Conducted':
        return 'status-conducted';
      case 'In Progress':
        return 'status-in-progress';
      case 'Pending':
        return 'status-pending';
      default:
        return '';
    }
  }

  getCompletionClass(percentage: string): string {
    const percent = parseFloat(percentage);
    if (percent === 100) return 'completion-full';
    if (percent >= 50) return 'completion-high';
    if (percent > 0) return 'completion-low';
    return 'completion-none';
  }
}